<template>
	<transition
			appear
			:appear-active-class="$_trnTstInpLyt_stylePageLayoutAnimation()">
		<v-row id="_trnTstInpLyt_top" class="customVRow" no-gutters>
			<v-col>
				<template v-if="$_trnTstInpLyt_infoTimeLimit > 0 && ( mode_.input || mode_.submit )">
					<v-row>
						<v-col>
							<v-system-bar 
									class="bar_" 
									color="transparent"
									fixed
									height="24">
								<v-progress-linear
										active
										height="24"
										query
										:value="$_trnTstInpLyt_getRemainingPercentage()">
									<template v-slot="{ value }">
										<template v-if="!isFalse(value)">
											<span class="overline" v-text="$_trnTstInpLyt_getCurrentTimeFormatted()" />
											<span class="overline">&nbsp;/&nbsp;</span>
											<span class="overline" v-text="$_trnTstInpLyt_getTimeLimitFormatted()" />
											<span class="overline">&nbsp;(&nbsp;</span>
											<span class="overline" v-text="$_trnTstInpLyt_getRemainingTimeFormatted()" />
											<span class="overline">&nbsp;)</span>
										</template>
									</template>
								</v-progress-linear>
							</v-system-bar>
						</v-col>
					</v-row>
				</template>
				<v-row no-gutters>
					<v-col>
						<v-stepper
								v-model="stepNumber_"
								class="stepper_"
								:dark="$_trnTstInpLyt_styleStepperDark"
								:light="$_trnTstInpLyt_styleStepperLight"
								:vertical="$_trnTstInpLyt_stateAppIsMobileScreen">
							<!-- stepper header ( only for web ) -->
							<template v-if="!$_trnTstInpLyt_stateAppIsMobileScreen">
								<v-row no-gutters>
									<v-col>
										<v-sheet
												class="customVSheet px-3 ma-3"
												:color="$_trnTstInpLyt_styleStepperSheetColor"
												:dark="$_trnTstInpLyt_styleStepperSheetDark"
												:elevation="$_trnTstInpLyt_styleStepperSheetElevation"
												:light="$_trnTstInpLyt_styleStepperSheetLight">
											<v-stepper-header class="stepperHeader_">
												<v-row>
													<template v-for="(stepVals, stepKey) in step_">
														<v-col :key="stepKey">
															<v-card	class="customVCard"
																	:color="$_trnTstInpLyt_styleStepperHeaderCardColor"
																	:dark="$_trnTstInpLyt_styleStepperHeaderCardDark"
																	:elevation="$_trnTstInpLyt_styleStepperHeaderCardElevation"
																	:flat="$_trnTstInpLyt_styleStepperHeaderCardFlat"
																	:hover="$_trnTstInpLyt_styleStepperHeaderCardHover"
																	:light="$_trnTstInpLyt_styleStepperHeaderCardLight"
																	:outlined="$_trnTstInpLyt_styleStepperHeaderCardOutlined"
																	:raised="$_trnTstInpLyt_styleStepperHeaderCardRaised"
																	:tile="$_trnTstInpLyt_styleStepperHeaderCardTile">
																<v-stepper-step 
																		class="stepperStep_"
																		:color="$_trnTstInpLyt_styleStepperStepColor"
																		:complete="completed_[stepKey]"
																		:step="stepVals.step">
																	<span v-html="stepVals.title" />
																</v-stepper-step>
															</v-card>
														</v-col>
													</template>
												</v-row>
											</v-stepper-header>
										</v-sheet>
									</v-col>
								</v-row>
							</template>
							<template v-if="errorMessage_">
								<v-row class="pt-3" no-gutters>
									<v-col>
										<v-card color="transparent" flat>
											<v-card-text>
												<span v-html="errorMessage_" />
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</template>
							<!-- stepper body ( start mode ) -->
							<v-stepper-items class="stepperItem_">
								<!-- stepper body - step head (only for mobile) -->
								<template v-if="$_trnTstInpLyt_stateAppIsMobileScreen">
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet px-3 ma-3"
													:color="$_trnTstInpLyt_styleStepperSheetColor"
													:dark="$_trnTstInpLyt_styleStepperSheetDark"
													:elevation="$_trnTstInpLyt_styleStepperSheetElevation"
													:light="$_trnTstInpLyt_styleStepperSheetLight">
												<v-row>
													<v-col>
														<v-card class="customVCard"
																:color="$_trnTstInpLyt_styleStepperHeaderCardColor"
																:dark="$_trnTstInpLyt_styleStepperHeaderCardDark"
																:elevation="$_trnTstInpLyt_styleStepperHeaderCardElevation"
																:flat="$_trnTstInpLyt_styleStepperHeaderCardFlat"
																:hover="$_trnTstInpLyt_styleStepperHeaderCardHover"
																:light="$_trnTstInpLyt_styleStepperHeaderCardLight"
																:outlined="$_trnTstInpLyt_styleStepperHeaderCardOutlined"
																:raised="$_trnTstInpLyt_styleStepperHeaderCardRaised"
																:tile="$_trnTstInpLyt_styleStepperHeaderCardTile">
															<v-stepper-step
																	class="stepperStep_"
																	:color="$_trnTstInpLyt_styleStepperStepColor"
																	:complete="completed_.start"
																	:step="step_.start.step">
																<span v-html="step_.start.title" />
															</v-stepper-step>
														</v-card>
													</v-col>
												</v-row>
											</v-sheet>
										</v-col>
									</v-row>
								</template>
								<!-- stepper body - step body -->
								<v-stepper-content
										class="stepperContent_"
										:step="step_.start.step">
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet px-3 ma-3"
													:color="$_trnTstInpLyt_styleStepperSheetColor"
													:dark="$_trnTstInpLyt_styleStepperSheetDark"
													:elevation="$_trnTstInpLyt_styleStepperSheetElevation"
													:light="$_trnTstInpLyt_styleStepperSheetLight">
												<v-row>
													<v-col>
														<v-card class="customVCard"
																:color="$_trnTstInpLyt_styleStepperBodyCardColor"
																:dark="$_trnTstInpLyt_styleStepperBodyCardDark"
																:elevation="$_trnTstInpLyt_styleStepperBodyCardElevation"
																:flat="$_trnTstInpLyt_styleStepperBodyCardFlat"
																:hover="$_trnTstInpLyt_styleStepperBodyCardHover"
																:light="$_trnTstInpLyt_styleStepperBodyCardLight"
																:outlined="$_trnTstInpLyt_styleStepperBodyCardOutlined"
																:raised="$_trnTstInpLyt_styleStepperBodyCardRaised"
																:tile="$_trnTstInpLyt_styleStepperBodyCardTile">
															<v-card-text>
																<v-row dense>
																	<v-col>
																		<span v-html="$_trnTstInpLyt_langStartText" />
																	</v-col>
																</v-row>
															</v-card-text>
														</v-card>
													</v-col>
												</v-row>
											</v-sheet>
										</v-col>
									</v-row>
									<v-row	align="center"
											justify="center">
										<!-- start button -->
										<v-col cols="auto">
											<v-btn	class="customVBtn"
													:block="$_trnTstInpLyt_styleStepperActionButtonBlock"
													:color="$_trnTstInpLyt_styleStepperActionButtonColorFinish"
													:dark="$_trnTstInpLyt_styleStepperActionButtonDark"
													:depressed="$_trnTstInpLyt_styleStepperActionButtonDepressed"
													:elevation="$_trnTstInpLyt_styleStepperActionButtonElevation"
													:large="$_trnTstInpLyt_styleStepperActionButtonLarge"
													:light="$_trnTstInpLyt_styleStepperActionButtonLight"
													:outlined="$_trnTstInpLyt_styleStepperActionButtonOutlined"
													:rounded="$_trnTstInpLyt_styleStepperActionButtonRounded"
													:small="$_trnTstInpLyt_styleStepperActionButtonSmall"
													:text="$_trnTstInpLyt_styleStepperActionButtonFlat"
													@click="$_trnTstInpLyt_start()">
												<template v-if="onProgress_">
													<progress-circular />
												</template>
												<template v-else>
													<span v-text="$_trnTstInpLyt_langStartButton" />
												</template>
											</v-btn>
										</v-col>
									</v-row>
								</v-stepper-content>
							</v-stepper-items>
							<!-- stepper body ( input mode ) -->
							<v-stepper-items class="stepperItem_">
								<!-- stepper body - step head (only for mobile) -->
								<template v-if="$_trnTstInpLyt_stateAppIsMobileScreen">
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet px-3 ma-3"
													:color="$_trnTstInpLyt_styleStepperSheetColor"
													:dark="$_trnTstInpLyt_styleStepperSheetDark"
													:elevation="$_trnTstInpLyt_styleStepperSheetElevation"
													:light="$_trnTstInpLyt_styleStepperSheetLight">
												<v-row>
													<v-col>
														<v-card class="customVCard"
																:color="$_trnTstInpLyt_styleStepperHeaderCardColor"
																:dark="$_trnTstInpLyt_styleStepperHeaderCardDark"
																:elevation="$_trnTstInpLyt_styleStepperHeaderCardElevation"
																:flat="$_trnTstInpLyt_styleStepperHeaderCardFlat"
																:hover="$_trnTstInpLyt_styleStepperHeaderCardHover"
																:light="$_trnTstInpLyt_styleStepperHeaderCardLight"
																:outlined="$_trnTstInpLyt_styleStepperHeaderCardOutlined"
																:raised="$_trnTstInpLyt_styleStepperHeaderCardRaised"
																:tile="$_trnTstInpLyt_styleStepperHeaderCardTile">
															<v-stepper-step
																	class="stepperStep_"
																	:color="$_trnTstInpLyt_styleStepperStepColor"
																	:complete="completed_.input"
																	:step="step_.input.step">
																<span v-html="step_.input.title" />
															</v-stepper-step>
														</v-card>
													</v-col>
												</v-row>
											</v-sheet>
										</v-col>
									</v-row>
								</template>
								<!-- stepper body - step body -->
								<v-stepper-content
										class="stepperContent_"
										:step="step_.input.step">
									<validation-observer v-slot="validation">
										<v-form>
											<v-row>
												<v-col>
													<v-sheet
															class="customVSheet px-3 ma-3"
															:color="$_trnTstInpLyt_styleStepperSheetColor"
															:dark="$_trnTstInpLyt_styleStepperSheetDark"
															:elevation="$_trnTstInpLyt_styleStepperSheetElevation"
															:light="$_trnTstInpLyt_styleStepperSheetLight">
														<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
															<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
																<template v-if="contentVals.title">
																	<v-row :key="`title-${contentKey}`">
																		<v-col>
																			<v-card class="customVCard"
																					:color="$_trnTstInpLyt_styleStepperBodyCardColor"
																					:dark="$_trnTstInpLyt_styleStepperBodyCardDark"
																					:elevation="$_trnTstInpLyt_styleStepperBodyCardElevation"
																					:flat="$_trnTstInpLyt_styleStepperBodyCardFlat"
																					:hover="$_trnTstInpLyt_styleStepperBodyCardHover"
																					:light="$_trnTstInpLyt_styleStepperBodyCardLight"
																					:outlined="$_trnTstInpLyt_styleStepperBodyCardOutlined"
																					:raised="$_trnTstInpLyt_styleStepperBodyCardRaised"
																					:tile="$_trnTstInpLyt_styleStepperBodyCardTile">
																				<v-card-text>
																					<v-row dense>
																						<v-col>
																							<span	class="title"
																									v-html="$_trnTstInpLyt_langContentTitle(contentVals)" />
																						</v-col>
																					</v-row>
																				</v-card-text>
																			</v-card>
																		</v-col>
																	</v-row>
																</template>
																<v-row :key="`content-${contentKey}`">
																	<v-col>
																		<v-card class="customVCard"
																				:color="$_trnTstInpLyt_styleStepperBodyCardColor"
																				:dark="$_trnTstInpLyt_styleStepperBodyCardDark"
																				:elevation="$_trnTstInpLyt_styleStepperBodyCardElevation"
																				:flat="$_trnTstInpLyt_styleStepperBodyCardFlat"
																				:hover="$_trnTstInpLyt_styleStepperBodyCardHover"
																				:light="$_trnTstInpLyt_styleStepperBodyCardLight"
																				:outlined="$_trnTstInpLyt_styleStepperBodyCardOutlined"
																				:raised="$_trnTstInpLyt_styleStepperBodyCardRaised"
																				:tile="$_trnTstInpLyt_styleStepperBodyCardTile">
																			<template v-if="isObject(contentVals.bigImage)">
																				<v-row>
																					<v-col>
																						<v-img	class="customVImg"
																								:src="$_trnTstInpLyt_styleContentBigImageUrl(contentVals)" />
																					</v-col>
																				</v-row>
																			</template>
																			<template v-if="isObject(contentVals.video)">
																				<v-row>
																					<v-col>
																						<card-video
																								:contentKey="contentKey"
																								:contents="contents"
																								:inits="inits" />
																					</v-col>
																				</v-row>
																			</template>
																			<v-row>
																				<template v-if="!isFalse($_trnTstInpLyt_langContentText(contentVals))">
																					<v-col>
																						<v-card-title>
																							<v-row no-gutters>
																								<v-col>
																									<span 	class="subtitle-1 markdown"
																											v-html="marked($_trnTstInpLyt_langContentText(contentVals))" />
																								</v-col>
																							</v-row>
																						</v-card-title>
																					</v-col>
																				</template>
																				<template v-if="isObject(contentVals.image)">
																					<v-col cols="12" md="4" class="center">
																						<v-img	class="customVImg"
																								:src="$_trnTstInpLyt_styleContentImageUrl(contentVals)" />
																					</v-col>
																				</template>
																			</v-row>
																			<v-row>
																				<v-col>
																					<v-card-text>
																						<!-- check box -->
																						<template v-if="contentVals.type.checkbox">
																							<v-row no-gutters>
																								<v-col>
																									<input-checkbox
																											:contentKey="contentKey"
																											:contents="contents"
																											:inits="inits" />
																								</v-col>
																							</v-row>
																						</template>
																						<!-- combobox -->
																						<template v-if="contentVals.type.combobox">
																							<v-row no-gutters>
																								<v-col>
																									<input-combobox
																											:contentKey="contentKey"
																											:contents="contents"
																											:inits="inits" />
																								</v-col>
																							</v-row>
																						</template>
																						<!-- combobox multiple -->
																						<template v-if="contentVals.type.comboboxMultiple">
																							<v-row no-gutters>
																								<v-col>
																									<input-combobox-multiple
																											:contentKey="contentKey"
																											:contents="contents"
																											:inits="inits" />
																								</v-col>
																							</v-row>
																						</template>
																						<!-- radio button -->
																						<template v-if="contentVals.type.radioButton">
																							<v-row no-gutters>
																								<v-col>
																									<input-radio-button
																											:contentKey="contentKey"
																											:contents="contents"
																											:inits="inits" />
																								</v-col>
																							</v-row>
																						</template>
																						<!-- select -->
																						<template v-if="contentVals.type.select">
																							<v-row no-gutters>
																								<v-col>
																									<input-select
																											:contentKey="contentKey"
																											:contents="contents"
																											:inits="inits" />
																								</v-col>
																							</v-row>
																						</template>
																						<!-- select multiple -->
																						<template v-if="contentVals.type.selectMultiple">
																							<v-row no-gutters>
																								<v-col>
																									<input-select-multiple
																											:contentKey="contentKey"
																											:contents="contents"
																											:inits="inits" />
																								</v-col>
																							</v-row>
																						</template>
																						<!-- slider -->
																						<template v-if="contentVals.type.slider">
																							<v-row no-gutters>
																								<v-col>
																									<input-slider
																											:contentKey="contentKey"
																											:contents="contents"
																											:inits="inits" />
																								</v-col>
																							</v-row>
																						</template>
																						<!-- switch -->
																						<template v-if="contentVals.type.switch">
																							<v-row no-gutters>
																								<v-col>
																									<input-switch
																											:contentKey="contentKey"
																											:contents="contents"
																											:inits="inits" />
																								</v-col>
																							</v-row>
																						</template>
																						<!-- textarea -->
																						<template v-if="contentVals.type.textarea">
																							<v-row no-gutters>
																								<v-col>
																									<input-textarea
																											:contentKey="contentKey"
																											:contents="contents"
																											:inits="inits" />
																								</v-col>
																							</v-row>
																						</template>
																						<!-- text field -->
																						<template v-if="contentVals.type.textField">
																							<v-row no-gutters>
																								<v-col>
																									<input-text-field
																											:contentKey="contentKey"
																											:contents="contents"
																											:inits="inits" />
																								</v-col>
																							</v-row>
																						</template>
																					</v-card-text>
																				</v-col>
																			</v-row>
																			<!-- action buttons --> 
																			<template v-if="!isEmpty(contentVals.actionButtons)">
																				<v-row>
																					<v-col>
																						<v-card-actions>
																							<v-row dense>
																								<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																									<v-col :key="actionButtonKey" cols="auto">
																										<v-btn	class="customVBtn"
																												:block="$_trnTstInpLyt_styleQuestionActionButtonBlock"
																												:color="$_trnTstInpLyt_styleQuestionActionButtonColor"
																												:dark="$_trnTstInpLyt_styleQuestionActionButtonDark"
																												:depressed="$_trnTstInpLyt_styleQuestionActionButtonDepressed"
																												:elevation="$_trnTstInpLyt_styleQuestionActionButtonElevation"
																												:large="$_trnTstInpLyt_styleQuestionActionButtonLarge"
																												:light="$_trnTstInpLyt_styleQuestionActionButtonLight"
																												:outlined="$_trnTstInpLyt_styleQuestionActionButtonOutlined"
																												:rounded="$_trnTstInpLyt_styleQuestionActionButtonRounded"
																												:small="$_trnTstInpLyt_styleQuestionActionButtonSmall"
																												:text="$_trnTstInpLyt_styleQuestionActionButtonFlat"
																												@click="openLink(actionButtonVals.link)"
																												v-text="$_trnTstInpLyt_langActionButtonTitle(actionButtonVals)" />
																									</v-col>
																								</template>
																							</v-row>
																						</v-card-actions>
																					</v-col>
																				</v-row>
																			</template>
																		</v-card>
																	</v-col>
																</v-row>
															</template>
														</template>
													</v-sheet>
												</v-col>
											</v-row>
											<v-row	align="center"
													justify="center">
												<v-col cols="auto">
													<v-btn	class="customVBtn"
															:block="$_trnTstInpLyt_styleStepperActionButtonBlock"
															:color="$_trnTstInpLyt_styleStepperActionButtonColorSubmit"
															:dark="!validation.passed && !validation.valid ? $_trnTstInpLyt_stateAppIsDarkTheme : $_trnTstInpLyt_styleStepperActionButtonDark"
															:depressed="$_trnTstInpLyt_styleStepperActionButtonDepressed"
															:elevation="$_trnTstInpLyt_styleStepperActionButtonElevation"
															:large="$_trnTstInpLyt_styleStepperActionButtonLarge"
															:light="$_trnTstInpLyt_styleStepperActionButtonLight"
															:outlined="$_trnTstInpLyt_styleStepperActionButtonOutlined"
															:rounded="$_trnTstInpLyt_styleStepperActionButtonRounded"
															:small="$_trnTstInpLyt_styleStepperActionButtonSmall"
															:text="$_trnTstInpLyt_styleStepperActionButtonFlat"

															:disabled="!validation.passed && !validation.valid"

															@click="$_trnTstInpLyt_submit()"
															v-text="$_trnTstInpLyt_langSubmitButton" />
												</v-col>
											</v-row>
										</v-form>
									</validation-observer>
								</v-stepper-content>
							</v-stepper-items>
							<!-- stepper body ( submit mode ) -->
							<v-stepper-items class="stepperItem_">
								<!-- stepper body - step header (only for mobile) -->
								<template v-if="$_trnTstInpLyt_stateAppIsMobileScreen">
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet px-3 ma-3"
													:color="$_trnTstInpLyt_styleStepperSheetColor"
													:dark="$_trnTstInpLyt_styleStepperSheetDark"
													:elevation="$_trnTstInpLyt_styleStepperSheetElevation"
													:light="$_trnTstInpLyt_styleStepperSheetLight">
												<v-row>
													<v-col>
														<v-card class="customVCard"
																:color="$_trnTstInpLyt_styleStepperHeaderCardColor"
																:dark="$_trnTstInpLyt_styleStepperHeaderCardDark"
																:elevation="$_trnTstInpLyt_styleStepperHeaderCardElevation"
																:flat="$_trnTstInpLyt_styleStepperHeaderCardFlat"
																:hover="$_trnTstInpLyt_styleStepperHeaderCardHover"
																:light="$_trnTstInpLyt_styleStepperHeaderCardLight"
																:outlined="$_trnTstInpLyt_styleStepperHeaderCardOutlined"
																:raised="$_trnTstInpLyt_styleStepperHeaderCardRaised"
																:tile="$_trnTstInpLyt_styleStepperHeaderCardTile">
															<v-stepper-step
																	class="stepperStep_"
																	:color="$_trnTstInpLyt_styleStepperStepColor"
																	:complete="completed_.submit"
																	:step="step_.submit.step">
																<span v-html="step_.submit.title" />
															</v-stepper-step>
														</v-card>
													</v-col>
												</v-row>
											</v-sheet>
										</v-col>
									</v-row>
								</template>
								<!-- stepper body - step body -->
								<v-stepper-content
										class="stepperContent_"
										:step="step_.submit.step">
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet px-3 ma-3"
													:color="$_trnTstInpLyt_styleStepperSheetColor"
													:dark="$_trnTstInpLyt_styleStepperSheetDark"
													:elevation="$_trnTstInpLyt_styleStepperSheetElevation"
													:light="$_trnTstInpLyt_styleStepperSheetLight">
												<template v-for="(answerVals, answerKey) in sortObject($_trnTstInpLyt_stateInputData, 'order')">
													<template v-if="answerVals.question.title">
														<v-row :key="`title-${answerKey}`">
															<v-col>
																<v-card class="customVCard"
																		:color="$_trnTstInpLyt_styleStepperBodyCardColor"
																		:dark="$_trnTstInpLyt_styleStepperBodyCardDark"
																		:elevation="$_trnTstInpLyt_styleStepperBodyCardElevation"
																		:flat="$_trnTstInpLyt_styleStepperBodyCardFlat"
																		:hover="$_trnTstInpLyt_styleStepperBodyCardHover"
																		:light="$_trnTstInpLyt_styleStepperBodyCardLight"
																		:outlined="$_trnTstInpLyt_styleStepperBodyCardOutlined"
																		:raised="$_trnTstInpLyt_styleStepperBodyCardRaised"
																		:tile="$_trnTstInpLyt_styleStepperBodyCardTile">
																	<v-card-text>
																		<v-row dense>
																			<v-col>
																				<span	class="title"
																						v-html="answerVals.question.title" />
																			</v-col>
																		</v-row>
																	</v-card-text>
																</v-card>
															</v-col>
														</v-row>
													</template>
													<v-row :key="`content-${answerKey}`">
														<v-col>
															<v-card class="customVCard"
																	:color="$_trnTstInpLyt_styleStepperBodyCardColor"
																	:dark="$_trnTstInpLyt_styleStepperBodyCardDark"
																	:elevation="$_trnTstInpLyt_styleStepperBodyCardElevation"
																	:flat="$_trnTstInpLyt_styleStepperBodyCardFlat"
																	:hover="$_trnTstInpLyt_styleStepperBodyCardHover"
																	:light="$_trnTstInpLyt_styleStepperBodyCardLight"
																	:outlined="$_trnTstInpLyt_styleStepperBodyCardOutlined"
																	:raised="$_trnTstInpLyt_styleStepperBodyCardRaised"
																	:tile="$_trnTstInpLyt_styleStepperBodyCardTile">
																<template v-if="!isFalse(answerVals.question.text)">
																	<v-card-title>
																		<v-row dense>
																			<v-col>
																				<span	class="subtitle-1 markdown"
																						v-html="marked(answerVals.question.text)" />
																			</v-col>
																		</v-row>
																	</v-card-title>
																</template>
																<v-card-text>
																	<template v-if="answerVals.type == 'checkbox' || answerVals.type == 'switch'">
																		<v-row dense>
																			<template v-for="(vals, key) in answerVals.answer">
																				<template v-if="vals.value">
																					<v-col :key="key" cols="auto">
																						<span 	class="subtitle-1"
																								v-html="vals.text" />
																					</v-col>
																				</template>
																			</template>
																		</v-row>
																	</template>
																	<template v-else-if="answerVals.type == 'combobox'">
																		<v-row dense>
																			<v-col cols="auto">
																				<template v-if="isObject(answerVals.answer)">
																					<span	class="subtitle-1"
																							v-html="answerVals.answer.text" />
																				</template>
																				<template v-else>
																					<span 	class="subtitle-1"
																							v-html="answerVals.answer" />
																				</template>
																			</v-col>
																		</v-row>
																	</template>
																	<template v-else-if="answerVals.type == 'comboboxMultiple'">
																		<v-row dense>
																			<template v-for="(vals, key) in answerVals.answer">
																				<template v-if="isObject(vals)">
																					<v-col :key="key" cols="auto">
																						<span 	class="subtitle-1"
																								v-html="vals.text" />
																					</v-col>
																				</template>
																				<template v-else>
																					<v-col :key="key" cols="auto">
																						<span 	class="subtitle-1"
																								v-html="vals" />
																					</v-col>
																				</template>
																			</template>
																		</v-row>
																	</template>
																	<template v-else-if="answerVals.type == 'radioButton' || answerVals.type == 'select'">
																		<v-row dense>
																			<v-col cols="auto">
																				<span 	class="subtitle-1"
																						v-html="answerVals.answer.text" />
																			</v-col>
																		</v-row>
																	</template>
																	<template v-else-if="answerVals.type == 'selectMultiple'">
																		<v-row dense>
																			<template v-for="(vals, key) in answerVals.answer">
																				<v-col :key="key" cols="auto">
																					<span 	class="subtitle-1"
																							v-html="vals.text" />
																				</v-col>
																			</template>
																		</v-row>
																	</template>
																	<template v-else>
																		<v-row dense>
																			<v-col cols="auto">
																				<span v-html="answerVals.answer" />
																			</v-col>
																		</v-row>
																	</template>
																</v-card-text>
															</v-card>
														</v-col>
													</v-row>
												</template>
											</v-sheet>
										</v-col>
									</v-row>
									<v-row	align="center"
											justify="center">
										<!-- back button -->
										<template v-if="!expired_">
											<v-col cols="auto">
												<v-btn	class="customVBtn"
														:block="$_trnTstInpLyt_styleStepperActionButtonBlock"
														:color="$_trnTstInpLyt_styleStepperActionButtonColorBack"
														:dark="$_trnTstInpLyt_styleStepperActionButtonDark"
														:depressed="$_trnTstInpLyt_styleStepperActionButtonDepressed"
														:elevation="$_trnTstInpLyt_styleStepperActionButtonElevation"
														:large="$_trnTstInpLyt_styleStepperActionButtonLarge"
														:light="$_trnTstInpLyt_styleStepperActionButtonLight"
														:outlined="$_trnTstInpLyt_styleStepperActionButtonOutlined"
														:rounded="$_trnTstInpLyt_styleStepperActionButtonRounded"
														:small="$_trnTstInpLyt_styleStepperActionButtonSmall"
														:text="$_trnTstInpLyt_styleStepperActionButtonFlat"
														@click="$_trnTstInpLyt_back()"
														v-text="$_trnTstInpLyt_langBackButton" />
											</v-col>
										</template>
										<!-- confirm button -->
										<v-col cols="auto">
											<v-btn	class="customVBtn"
													:block="$_trnTstInpLyt_styleStepperActionButtonBlock"
													:color="$_trnTstInpLyt_styleStepperActionButtonColorConfirm"
													:dark="$_trnTstInpLyt_styleStepperActionButtonDark"
													:depressed="$_trnTstInpLyt_styleStepperActionButtonDepressed"
													:elevation="$_trnTstInpLyt_styleStepperActionButtonElevation"
													:large="$_trnTstInpLyt_styleStepperActionButtonLarge"
													:light="$_trnTstInpLyt_styleStepperActionButtonLight"
													:outlined="$_trnTstInpLyt_styleStepperActionButtonOutlined"
													:rounded="$_trnTstInpLyt_styleStepperActionButtonRounded"
													:small="$_trnTstInpLyt_styleStepperActionButtonSmall"
													:text="$_trnTstInpLyt_styleStepperActionButtonFlat"
													@click="$_trnTstInpLyt_confirm()">
												<template v-if="onProgress_">
													<progress-circular />
												</template>
												<template v-else>
													<span v-text="$_trnTstInpLyt_langConfirmButton" />
												</template>
											</v-btn>
										</v-col>
									</v-row>
								</v-stepper-content>
							</v-stepper-items>
							<!-- stepper body ( finish mode ) -->
							<v-stepper-items class="stepperItem_">
								<!-- stepper body - step header (only for mobile) -->
								<template v-if="$_trnTstInpLyt_stateAppIsMobileScreen">
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet px-3 ma-3"
													:color="$_trnTstInpLyt_styleStepperSheetColor"
													:dark="$_trnTstInpLyt_styleStepperSheetDark"
													:elevation="$_trnTstInpLyt_styleStepperSheetElevation"
													:light="$_trnTstInpLyt_styleStepperSheetLight">
												<v-row>
													<v-col>
														<v-card class="customVCard"
																:color="$_trnTstInpLyt_styleStepperHeaderCardColor"
																:dark="$_trnTstInpLyt_styleStepperHeaderCardDark"
																:elevation="$_trnTstInpLyt_styleStepperHeaderCardElevation"
																:flat="$_trnTstInpLyt_styleStepperHeaderCardFlat"
																:hover="$_trnTstInpLyt_styleStepperHeaderCardHover"
																:light="$_trnTstInpLyt_styleStepperHeaderCardLight"
																:outlined="$_trnTstInpLyt_styleStepperHeaderCardOutlined"
																:raised="$_trnTstInpLyt_styleStepperHeaderCardRaised"
																:tile="$_trnTstInpLyt_styleStepperHeaderCardTile">
															<v-stepper-step
																	class="stepperStep_"
																	:color="$_trnTstInpLyt_styleStepperStepColor"
																	:complete="completed_.finish"
																	:step="step_.finish.step">
																<span v-html="step_.finish.title" />
															</v-stepper-step>
														</v-card>
													</v-col>
												</v-row>
											</v-sheet>
										</v-col>
									</v-row>
								</template>
								<!-- stepper body - step body -->
								<v-stepper-content
										class="stepperContent_"
										:step="step_.finish.step">
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet px-3 ma-3"
													:color="$_trnTstInpLyt_styleStepperSheetColor"
													:dark="$_trnTstInpLyt_styleStepperSheetDark"
													:elevation="$_trnTstInpLyt_styleStepperSheetElevation"
													:light="$_trnTstInpLyt_styleStepperSheetLight">
												<v-row>
													<v-col>
														<v-card class="customVCard"
																:color="$_trnTstInpLyt_styleStepperBodyCardColor"
																:dark="$_trnTstInpLyt_styleStepperBodyCardDark"
																:elevation="$_trnTstInpLyt_styleStepperBodyCardElevation"
																:flat="$_trnTstInpLyt_styleStepperBodyCardFlat"
																:hover="$_trnTstInpLyt_styleStepperBodyCardHover"
																:light="$_trnTstInpLyt_styleStepperBodyCardLight"
																:outlined="$_trnTstInpLyt_styleStepperBodyCardOutlined"
																:raised="$_trnTstInpLyt_styleStepperBodyCardRaised"
																:tile="$_trnTstInpLyt_styleStepperBodyCardTile">
															<v-card-text>
																<v-row dense>
																	<v-col>
																		<span 	class="title"
																				v-html="$_trnTstInpLyt_langFinishedText" />
																	</v-col>
																</v-row>
															</v-card-text>
														</v-card>
													</v-col>
												</v-row>
											</v-sheet>
										</v-col>
									</v-row>
									<v-row	align="center"
											justify="center">
										<!-- ok button -->
										<v-col cols="auto">
											<v-btn	class="customVBtn"
													:block="$_trnTstInpLyt_styleStepperActionButtonBlock"
													:color="$_trnTstInpLyt_styleStepperActionButtonColorFinish"
													:dark="$_trnTstInpLyt_styleStepperActionButtonDark"
													:depressed="$_trnTstInpLyt_styleStepperActionButtonDepressed"
													:elevation="$_trnTstInpLyt_styleStepperActionButtonElevation"
													:large="$_trnTstInpLyt_styleStepperActionButtonLarge"
													:light="$_trnTstInpLyt_styleStepperActionButtonLight"
													:outlined="$_trnTstInpLyt_styleStepperActionButtonOutlined"
													:rounded="$_trnTstInpLyt_styleStepperActionButtonRounded"
													:small="$_trnTstInpLyt_styleStepperActionButtonSmall"
													:text="$_trnTstInpLyt_styleStepperActionButtonFlat"
													@click="openLink($_trnTstInpLyt_linkOkButton)"
													v-text="$_trnTstInpLyt_langOkButton" />
										</v-col>
									</v-row>
								</v-stepper-content>
							</v-stepper-items>
						</v-stepper>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'TrainingTestInputLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				valid_: true,

				errorMessage_: null,
				onProgress_: false,

				stepNumber_: 1,

				mode_: {
					//
				},

				completed_: {
					//
				},

				step_: {
					//
				},

				// for time limit
				currentTime_: 0,
				startTime_: null,
				interval_: null,
				expired_: false
			}
		},
		computed: {
			// params
			$_trnTstInpLyt_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_trnTstInpLyt_paramsTrainingCourseCode() {
				const self_ = this;
				const params_ = self_.$_trnTstInpLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.trainingCourseCode
			},
			$_trnTstInpLyt_paramsTrainingModuleCode() {
				const self_ = this;
				const params_ = self_.$_trnTstInpLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.trainingModuleCode
			},
			$_trnTstInpLyt_paramsTrainingSectionCode() {
				const self_ = this;
				const params_ = self_.$_trnTstInpLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.trainingSectionCode
			},
			// current user
			$_trnTstInpLyt_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_trnTstInpLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_trnTstInpLyt_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			$_trnTstInpLyt_stateInput() {
				const self_ = this;
				return self_.getInputState()
			},
			$_trnTstInpLyt_stateInputData() {
				const self_ = this;
				const input_ = self_.$_trnTstInpLyt_stateInput;
				if(self_.isFalse(input_)) { return null }
				return input_.data
			},
			$_trnTstInpLyt_statePageName() {
				const self_ = this;
				return self_.getPageState('name')
			},
			$_trnTstInpLyt_statePageType() {
				const self_ = this;
				return self_.getPageState('type')
			},
			// info
			$_trnTstInpLyt_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'contact')
			},
			$_trnTstInpLyt_infoContactUid() {
				const self_ = this;
				const contact_ = self_.$_trnTstInpLyt_infoContact;
				if(self_.isEmpty(contact_)) { return null }
				return contact_.uid
			},
			$_trnTstInpLyt_infoMessage() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'message')
			},
			$_trnTstInpLyt_infoMessageTitle() {
				const self_ = this;
				const message_ = self_.$_trnTstInpLyt_infoMessage;
				if(self_.isEmpty(message_)) { return null }
				return message_.title
			},
			$_trnTstInpLyt_infoMessageText() {
				const self_ = this;
				const message_ = self_.$_trnTstInpLyt_infoMessage;
				if(self_.isEmpty(message_)) { return null }
				return message_.text
			},
			$_trnTstInpLyt_infoMaxScore() {
				const self_ = this;
				const input_ = self_.getInitsInfoVal(self_.inits, 'input')
				if(self_.isEmpty(input_)) { return null }
				return input_.maxScore
			},
			$_trnTstInpLyt_infoMinScore() {
				const self_ = this;
				const input_ = self_.getInitsInfoVal(self_.inits, 'input')
				if(self_.isEmpty(input_)) { return null }
				return input_.minScore
			},
			$_trnTstInpLyt_infoTimeLimit() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'timeLimit')
			},
			// lang
			$_trnTstInpLyt_langStartText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'startText')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_trnTstInpLyt_langStartButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'startButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_trnTstInpLyt_langBackButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'backButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_trnTstInpLyt_langSubmitButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'submitButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_trnTstInpLyt_langConfirmButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'confirmButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_trnTstInpLyt_langFinishedText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishText')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_trnTstInpLyt_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'okButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_trnTstInpLyt_langMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'message')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_trnTstInpLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_trnTstInpLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_trnTstInpLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// link
			$_trnTstInpLyt_linkOkButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.inits, 'okButton')
			},
			// style
			$_trnTstInpLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_trnTstInpLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_trnTstInpLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_trnTstInpLyt_styleStepper() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepper')
			},
			$_trnTstInpLyt_styleStepperDark() {
				const self_ = this;
				const stepper_ = self_.$_trnTstInpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.dark)
			},
			$_trnTstInpLyt_styleStepperLight() {
				const self_ = this;
				const stepper_ = self_.$_trnTstInpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.light)
			},
			$_trnTstInpLyt_styleStepperStepColor() {
				const self_ = this;
				const stepper_ = self_.$_trnTstInpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.stepColor)
			},
			$_trnTstInpLyt_styleStepperSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperSheet')
			},
			$_trnTstInpLyt_styleStepperSheetColor() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_trnTstInpLyt_styleStepperSheetDark() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_trnTstInpLyt_styleStepperSheetElevation() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_trnTstInpLyt_styleStepperSheetLight() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_trnTstInpLyt_styleStepperHeaderCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperHeaderCard')
			},
			$_trnTstInpLyt_styleStepperHeaderCardColor() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_trnTstInpLyt_styleStepperHeaderCardDark() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_trnTstInpLyt_styleStepperHeaderCardElevation() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_trnTstInpLyt_styleStepperHeaderCardFlat() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_trnTstInpLyt_styleStepperHeaderCardHover() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_trnTstInpLyt_styleStepperHeaderCardLight() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_trnTstInpLyt_styleStepperHeaderCardOutlined() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_trnTstInpLyt_styleStepperHeaderCardRaised() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_trnTstInpLyt_styleStepperHeaderCardTile() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_trnTstInpLyt_styleStepperBodyCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperBodyCard')
			},
			$_trnTstInpLyt_styleStepperBodyCardColor() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_trnTstInpLyt_styleStepperBodyCardDark() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_trnTstInpLyt_styleStepperBodyCardElevation() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_trnTstInpLyt_styleStepperBodyCardFlat() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_trnTstInpLyt_styleStepperBodyCardHover() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_trnTstInpLyt_styleStepperBodyCardLight() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_trnTstInpLyt_styleStepperBodyCardOutlined() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_trnTstInpLyt_styleStepperBodyCardRaised() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_trnTstInpLyt_styleStepperBodyCardTile() {
				const self_ = this;
				const card_ = self_.$_trnTstInpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_trnTstInpLyt_styleStepperActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperActionButton')
			},
			$_trnTstInpLyt_styleStepperActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_trnTstInpLyt_styleStepperActionButtonColorSubmit() {
				const self_ = this;
				const actionButton_ =self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.submit) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_trnTstInpLyt_styleStepperActionButtonColorBack() {
				const self_ = this;
				const actionButton_ =self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.back) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_trnTstInpLyt_styleStepperActionButtonColorConfirm() {
				const self_ = this;
				const actionButton_ =self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.confirm) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_trnTstInpLyt_styleStepperActionButtonColorFinish() {
				const self_ = this;
				const actionButton_ =self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				if(self_.isObject(actionButton_.color)) {
					return	self_.getStylesVal(actionButton_.color.finish) ||
							self_.getStylesVal(actionButton_.color.default)
				} else {
					return self_.getStylesVal(actionButton_.color)
				}
			},
			$_trnTstInpLyt_styleStepperActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_trnTstInpLyt_styleStepperActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_trnTstInpLyt_styleStepperActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_trnTstInpLyt_styleStepperActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_trnTstInpLyt_styleStepperActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_trnTstInpLyt_styleStepperActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_trnTstInpLyt_styleStepperActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_trnTstInpLyt_styleStepperActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_trnTstInpLyt_styleStepperActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_trnTstInpLyt_styleQuestionActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'questionActionButton')
			},
			$_trnTstInpLyt_styleQuestionActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_trnTstInpLyt_styleQuestionActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_trnTstInpLyt_styleQuestionActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_trnTstInpLyt_styleQuestionActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_trnTstInpLyt_styleQuestionActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_trnTstInpLyt_styleQuestionActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_trnTstInpLyt_styleQuestionActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_trnTstInpLyt_styleQuestionActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_trnTstInpLyt_styleQuestionActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_trnTstInpLyt_styleQuestionActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_trnTstInpLyt_styleQuestionActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_trnTstInpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_trnTstInpLyt_styleContentBigImage() {
				return contentVals => {
					return contentVals.bigImage
				}
			},
			$_trnTstInpLyt_styleContentBigImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_trnTstInpLyt_styleContentBigImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_trnTstInpLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_trnTstInpLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_trnTstInpLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		watch: {
			currentTime_: '$_trnTstInpLyt_checkTime'
		},
		created() {
			const self_ = this;

			// set initial input state
			self_.$_trnTstInpLyt_setInputState()
		},
		beforeMount() {
			const self_ = this;
			
			self_.mode_ = {
				start: true,
				input: false,
				submit: false,
				finish: false
			}

			self_.step_ = {
				start: { step: 1, title: 'Start' },
				input: { step: 2, title: 'Input' },
				submit: { step: 3, title: 'Submit' },
				finish: { step: 4, title: 'Finished' }
			}
		},
		beforeDestroy() {
			const self_ = this;
			clearInterval(self_.interval_);			
		},
		methods: {
			$_trnTstInpLyt_setInputState() {
				const self_ = this;

				self_.setInputState('pageName', self_.$_trnTstInpLyt_statePageName)
				self_.setInputState('pageType', self_.$_trnTstInpLyt_statePageType)

				let data_ = {}

				Object.keys(self_.contents).forEach(key => {
					data_[key] = {}

					// order
					data_[key].order = self_.contents[key].order;

					// question title & text
					data_[key].question = {}
					data_[key].question.title = self_.$_trnTstInpLyt_langContentTitle(self_.contents[key])
					data_[key].question.text = self_.$_trnTstInpLyt_langContentText(self_.contents[key])

					// type
					Object.keys(self_.contents[key].type).forEach(typeKey => {
						if(self_.contents[key].type[typeKey]) { data_[key].type = typeKey }
					})

					// default answer (empty or zero)
					if(		self_.contents[key].type.combobox || // (free text)
							self_.contents[key].type.textarea || 
							self_.contents[key].type.textField ) { 
						data_[key].answer = '';
					} else if(	self_.contents[key].type.slider ) { 
						data_[key].answer = 0
					} else if(	self_.contents[key].type.comboboxMultiple || 
								self_.contents[key].type.selectMultiple ) { 
						data_[key].answer = [] 
					} else if(	self_.contents[key].type.checkbox || 
								self_.contents[key].type.switch ) { 
						data_[key].answer = {}

						const options_ = self_.contents[key].options

						Object.keys(options_).forEach(optionKey => {
							data_[key].answer[optionKey] = {
								value: false,
								order: options_[optionKey].order,
								text: options_[optionKey].text,
								isCorrectAnswer: options_[optionKey].isCorrectAnswer
							}
						})
					} else { // radio, combobox (select option), select
						data_[key].answer = {}
					}	

					// score
					data_[key].score = self_.contents[key].score;
				})

				self_.setInputState('data', data_)

				return
			},
			// button action
			$_trnTstInpLyt_start() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				const uid_ = self_.$_trnTstInpLyt_currentUserUid;

				const courseCode_ = self_.$_trnTstInpLyt_paramsTrainingCourseCode;
				const moduleCode_ = self_.$_trnTstInpLyt_paramsTrainingModuleCode;
				const sectionCode_ = self_.$_trnTstInpLyt_paramsTrainingSectionCode;

				if(self_.isFalse(courseCode_) || self_.isFalse(moduleCode_) || self_.isFalse(sectionCode_)) {
					self_.errorMessage_ = 'Cannot get training parameter.';
					return
				}

				const status_ = self_.getUserTrainingStatus(uid_, courseCode_, moduleCode_, sectionCode_)

				if(status_ == 'opened') {
					self_.errorMessage_ = 'Test is not started yet.';
					return
				}
				if(status_ == 'finished') {
					self_.errorMessage_ = 'Test was already finished.';
					return
				}
				if(status_ == 'close') {
					self_.errorMessage_ = 'Test is closed.';
					return
				}

				self_.onProgress_ = true;

				Promise.resolve().then(() => {
					return self_.updateUserTrainingStatus(uid_, courseCode_, moduleCode_, sectionCode_, 'finished')
				}).then(() => {
					const nextSectionCode_ = self_.getNextSectionCode(courseCode_, moduleCode_, sectionCode_)
					// complete module
					if(self_.isFalse(nextSectionCode_)) {
						return self_.updateUserTrainingStatus(uid_, courseCode_, moduleCode_, null, 'finished')
					}
					// start next section
					else {
						return self_.updateUserTrainingStatus(uid_, courseCode_, moduleCode_, nextSectionCode_, 'started')
					}
				}).then(() => {
					return self_.initializeUser('trainingData')
				}).then(() => {
					self_.mode_ = { 
						start: false,
						input: true,
						submit: false,
						finish: false
					}

					self_.stepNumber_++;

					self_.completed_ = { 
						start: true,
						input: false,
						submit: false,
						finish: false
					}

					self_.onProgress_ = false;

					self_.startTime_ = new Date()

					self_.interval_ = setInterval(() => { self_.$_trnTstInpLyt_getCurrentTime() }, 1000)
				}).catch(error => {
/* error */			self_.logError('Error', '$_trnTstInpLyt_start()', error)
				})
			},
			$_trnTstInpLyt_submit() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				self_.mode_ = { 
					start: false,
					input: false,
					submit: true,
					finish: false
				}

				self_.completed_ = { 
					start: true,
					input: true,
					submit: false,
					finish: false
				}

				self_.stepNumber_++;

				self_.errorMessage_ = '';

				vuetify_.goTo('#_trnTstInpLyt_top')
			},
			$_trnTstInpLyt_back() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				self_.mode_ = {
					start: false,
					input: true,
					submit: false,
					finish: false
				}

				self_.stepNumber_--;

				self_.completed_ = { 
					start: true,
					input: false,
					submit: false,
					finish: false
				}

				self_.errorMessage_ = '';

				vuetify_.goTo('#_trnTstInpLyt_top')
			},
			$_trnTstInpLyt_confirm() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				if(self_.onProgress_) { return }

				self_.onProgress_ = true;

				const courseCode_ = self_.$_trnTstInpLyt_paramsTrainingCourseCode;
				const moduleCode_ = self_.$_trnTstInpLyt_paramsTrainingModuleCode;
				const sectionCode_ = self_.$_trnTstInpLyt_paramsTrainingSectionCode;
				// time & finished datetime
				clearInterval(self_.interval_);
				const time_ = Math.floor(self_.currentTime_)
				const startedDatetime_ = self_.formatDate(self_.startTime_, 'YYYY-MM-DD HH:mm:ss')
				const finishedDatetime_ = self_.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
				// score & correct answer
				let score_ = 0;
				let data_ = self_.getInputState('data')

				Object.keys(data_).forEach(key => {
					// radio button
					if(data_[key].type == 'radioButton') {
						if(data_[key].answer.isCorrectAnswer) {
							data_[key].isCorrect = true;
						} else { data_[key].isCorrect = false; }
					}
					// checkbox
					if(data_[key].type == 'checkbox') {
						const answer_ = data_[key].answer;

						let result_ = true;

						Object.keys(answer_).forEach(answerKey => {
							const correct_ =	( answer_[answerKey].value && answer_[answerKey].isCorrectAnswer ) ||
												( self_.isFalse(answer_[answerKey].value) && self_.isFalse(answer_[answerKey].isCorrectAnswer) )
							
							result_ = result_ && correct_;
						})

						data_[key].isCorrect = result_;
					}
					// score
					if(data_[key].isCorrect) { score_ += data_[key].score; }
				})
				self_.setInputState('data', data_)

				Promise.resolve().then(() => {
					return self_.storeTrainingTests(courseCode_, moduleCode_, sectionCode_, startedDatetime_, finishedDatetime_, time_, score_)
				}).then(() => {
					self_.mode_ = { 
						start: false,
						input: false,
						submit: false,
						finish: true
					}

					self_.stepNumber_++;

					self_.completed_ = { 
						start: true,
						input: true,
						submit: true,
						finish: false
					}

					self_.onProgress_ = false;

					return
				}).then(() => {
					self_.errorMessage_ = '';
					vuetify_.goTo('#_trnTstInpLyt_top')
				}).catch(error => {
/* error */			self_.logError('Error', '$_trnTstInpLyt_confirm()', error)
				})
			},
			// timer
			$_trnTstInpLyt_getCurrentTime() {
				const self_ = this;

				const now_ = Date.now()

				self_.currentTime_ = ( now_ - self_.startTime_ ) / 1000;
			},
			$_trnTstInpLyt_getCurrentTimeFormatted() {
				const self_ = this;

				const seconds_ = Math.floor(self_.currentTime_) % 60;
				const minutes_ = Math.floor(self_.currentTime_ / 60) % 60;

				return minutes_ + ':' + ('0' + seconds_).slice(-2);
			},
			$_trnTstInpLyt_getTimeLimitFormatted() {
				const self_ = this;
				
				const limit_ = self_.$_trnTstInpLyt_infoTimeLimit;

				const seconds_ = Math.floor(limit_) % 60;
				const minutes_ = Math.floor(limit_ / 60) % 60;

				return minutes_ + ':' + ('0' + seconds_).slice(-2);
			},
			$_trnTstInpLyt_getRemainingTime() {
				const self_ = this;

				const limit_ = self_.$_trnTstInpLyt_infoTimeLimit;

				let remaining_ = null
				
				if(limit_ > self_.currentTime_) {
					remaining_ = limit_ - self_.currentTime_ + 1;
				} else {
					remaining_ = 0;
				}

				return remaining_
			},
			$_trnTstInpLyt_getRemainingTimeFormatted() {
				const self_ = this;

				const remaining_ = self_.$_trnTstInpLyt_getRemainingTime()

				const seconds_ = Math.floor(remaining_) % 60;
				const minutes_ = Math.floor(remaining_ / 60) % 60;

				return minutes_ + ':' + ('0' + seconds_).slice(-2);
			},
			$_trnTstInpLyt_getRemainingPercentage() {
				const self_ = this;

				const limit_ = self_.$_trnTstInpLyt_infoTimeLimit;
				const remaining_ = self_.$_trnTstInpLyt_getRemainingTime()

				return 100 - ( remaining_ / limit_ * 100 )
			},
			$_trnTstInpLyt_checkTime() {
				const self_ = this;
				
				const percentage_ = self_.$_trnTstInpLyt_getRemainingPercentage()

				if(percentage_ >= 100 && !self_.expired_) {
					self_.expired_ = true  

					clearInterval(self_.interval_)

					if(self_.mode_.input) {
						self_.$_trnTstInpLyt_submit()
					}
				}
			}
		}
	}
</script>

<style scoped>
	@media screen and (min-width:960px) {
		.bar_ {
			margin-top: 64px;
			padding: 0;
		}
	}
	@media screen and (max-width:959px) {
		.bar_ {
			margin-top: 56px;
			padding: 0;
		}
	}
	.stepper_ {
		box-shadow: none;
		background-color: transparent;
	}
	.stepperHeader_ {
		background-color: transparent;
		box-shadow: none;
		height: 80px;
	}
	.stepperItem_ {
		background-color: transparent;
		box-shadow: none;
	}
	.stepperStep_ {
		padding: 16px !important;
	}
	.stepperContent_ {
		margin: 0 !important; 
		padding: 0 !important;
	}
</style>
